<template>
  <div class="app-container">
    <!-- 查询条件 -->

    <el-card shadow="never" v-loading="loading">
      <!-- 基础信息、数据分析等 -->
      <el-descriptions title="基础信息" style="margin-bottom: 20px;">
        <el-descriptions-item label="主播信息">{{ anchorInfo }}</el-descriptions-item>
        <el-descriptions-item label="直播信息">{{ liveInfo }}</el-descriptions-item>
        <el-descriptions-item label="直播类型">{{ liveTypeText }}</el-descriptions-item>
        <el-descriptions-item label="管理员" v-if="liveAdminCount > 0">
          {{ liveAdminCount }}人 <el-link type="primary" @click="showAdminDialog">查看管理员</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(liveData.livePO && liveData.livePO.createdTime) }}</el-descriptions-item>
        <el-descriptions-item label="直播时间">{{ liveTimeText }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="数据分析" style="margin-bottom: 20px;">
        <el-descriptions-item label="观看人数">
          {{ (liveData.livePO && liveData.livePO.lookUserCount) || 0 }}人 
          <el-link type="primary" @click="handleViewUsers">查看观看人数</el-link>
        </el-descriptions-item>
        <!-- <el-descriptions-item label="评论人数">{{ (liveData.livePO && liveData.livePO.speakCount) || 0 }}人</el-descriptions-item> -->
        <el-descriptions-item label="平均观看时长">{{ liveData.livePO.lookAverageSeconds }}</el-descriptions-item>
        <el-descriptions-item label="打赏人数">{{ (liveData.livePO && liveData.livePO.rewardUserCount) || 0 }}人</el-descriptions-item>
        <el-descriptions-item label="下单人数">{{ (liveData.livePO && liveData.livePO.orderUserCount) || 0 }}人</el-descriptions-item>
        <el-descriptions-item label="分享次数">
          {{ (liveData.livePO && liveData.livePO.shareCount) || 0 }}次 
          <el-link type="primary" @click="showShareDetailDialog">查看明细</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="本场点赞">{{ (liveData.livePO && liveData.livePO.likeCount) || 0 }}次</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="直播服务" style="margin-bottom: 20px;">
        <el-descriptions-item label="发放福袋">
          {{ (liveData.livePO && liveData.livePO.likeCount) || 0 }}次 
          <el-link type="primary" @click="handleViewLuckyBag">查看福袋</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="直播商品">{{ ((liveData.livePO && liveData.livePO.yueGoodsCount) || 0) + ((liveData.livePO && liveData.livePO.killGoodsCount) || 0) }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="直播收益" style="margin-bottom: 20px;">
        <el-descriptions-item label="打赏次数">{{ (liveData.livePO && liveData.livePO.rewardCount) || 0 }}次</el-descriptions-item>
        <!-- <el-descriptions-item label="打赏现金">{{ (liveData.livePO && liveData.livePO.rewardCashAmount) || 0 }}元</el-descriptions-item> -->
        <el-descriptions-item label="打赏零售价">{{ (liveData.livePO && liveData.livePO.rewardXdbAmount) || 0 }}小杜比</el-descriptions-item>
        <el-descriptions-item label="下单数量">{{ ((liveData.livePO && liveData.livePO.yueOrderCount) || 0) + ((liveData.livePO && liveData.livePO.killOrderCount) || 0) }}</el-descriptions-item>
        <el-descriptions-item label="余额商城订单">
          {{ (liveData.livePO && liveData.livePO.yueOrderCount) || 0 }} 
          <el-link type="primary" @click="handleViewYueOrders">查看订单</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="秒杀订单">
          {{ (liveData.livePO && liveData.livePO.killOrderCount) || 0 }} 
          <el-link type="primary" @click="handleViewKillOrders">查看订单</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="充值次数">
          {{ (liveData.livePO && liveData.livePO.tuitionCount) || 0 }} 
          <el-link type="primary" @click="handleViewTuitionOrders">查看充值订单</el-link>
        </el-descriptions-item>
      </el-descriptions>
      <!-- 直播商品表格 -->
      <el-table :data="tableData" style="margin-top: 20px;" v-loading="tableLoading">
        <el-table-column prop="name" label="直播商品" />
        <el-table-column prop="type" label="商品类型" />
        <el-table-column prop="count" label="商品点击量" />
        <el-table-column prop="canBuy" label="是否允许购买" />
        <el-table-column prop="upTime" label="上架时间" />
        <el-table-column prop="duration" label="持续时间" />
        <el-table-column prop="downTime" label="下架时间" />
        <el-table-column prop="sales" label="销量" />
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <adminisVue ref="adminisVue" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import adminisVue from './admins.vue'
import liveManageApi from '@/api/live/liveManage'
import { parseTime } from '@/utils'

export default {
  components: { Pagination, adminisVue },
  data() {
    return {
      loading: false,
      tableLoading: false,
      liveId: null,
      liveData: {
        liveAnchorPO: {},
        livePO: {},
        liveAdminPOList: [],
        liveAuthPO: {},
        userPO: {}
      },
      filters: {
        anchorType: '',
        anchorPhone: '',
        liveInfo: '',
        liveTheme: '',
        orderType: '',
        isCancel: '',
        // 其他筛选项
      },
      query: {
        pageNo: 1,
        pageSize: 10,
        // 其他筛选参数
      },
      tableData: [
        // 表格数据
      ],
      total: 0,
      // ...
    }
  },
  computed: {
    // 主播信息
    anchorInfo() {
      const anchor = this.liveData.liveAnchorPO
      if (!anchor) return '-'
      const name =anchor.liveName || '-'
      const position = anchor.position || ''
      const phone = anchor.phone || ''
      return `${name}${position ? `(${position})` : ''}${phone ? phone : ''}`
    },
    // 直播信息
    liveInfo() {
      const live = this.liveData.livePO
      if (!live) return '-'
      const id = live.id || ''
      const title = live.title || '无标题'
      const state = this.getLiveStateText(live.state)
      return `${id}-${title}-${state}`
    },
    // 直播类型
    liveTypeText() {
      const liveType = this.liveData.livePO && this.liveData.livePO.liveType
      const typeMap = {
        1: '带货竖屏直播',
        2: '培训横屏直播'
      }
      return typeMap[liveType] || '未知类型'
    },
    // 直播时间
    liveTimeText() {
      const live = this.liveData.livePO
      if (!live) return '-'
      const startTime = this.formatTime(live.startTime)
      const endTime = this.formatTime(live.endTime)
      
      if (startTime && endTime && startTime !== '-' && endTime !== '-') {
        // 根据开始时间和结束时间计算实际时长
        const startDate = this.parseTimeToDate(live.startTime)
        const endDate = this.parseTimeToDate(live.endTime)
        
        if (startDate && endDate && endDate > startDate) {
          // 计算时间差（秒）
          const diffSeconds = Math.floor((endDate - startDate) / 1000)
          const duration = this.formatDuration(diffSeconds)
          return `${startTime}-${endTime}共计${duration}`
        } else {
          // 如果无法计算，使用 timeSpan 字段
          const timeSpan = live.timeSpan || 0
          const duration = this.formatDuration(timeSpan)
          return `${startTime}-${endTime}共计${duration}`
        }
      }
      return startTime || endTime || '-'
    },
    // 管理员数量
    liveAdminCount() {
      return (this.liveData.liveAdminPOList && this.liveData.liveAdminPOList.length) || 0
    }
  },
  created() {
    // 从路由参数获取liveId
    if (this.$route.query.liveId) {
      this.liveId = parseInt(this.$route.query.liveId)
      this.fetchLiveData()
    } else {
      this.$message.error('缺少直播ID参数')
    }
  },
  methods: {
    // 获取直播数据
    async fetchLiveData() {
      if (!this.liveId) return
      this.loading = true
      try {
        const response = await liveManageApi.getLiveById(this.liveId)
        if (response.code === '0' && response.data) {
          this.liveData = response.data
          // 如果有管理员数据，传递给子组件
          if (this.liveData.liveAdminPOList && this.liveData.liveAdminPOList.length > 0) {
            // 可以在这里处理管理员数据
          }
        } else {
          this.$message.error(response.message || '获取直播数据失败')
        }
      } catch (error) {
        console.error('获取直播数据失败:', error)
        this.$message.error('获取直播数据失败')
      } finally {
        this.loading = false
      }
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      // 如果是时间戳，转换为日期格式
      if (typeof time === 'number') {
        return new Date(time).toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).replace(/\//g, '-')
      }
      // 如果是字符串，直接返回
      return time
    },
    // 解析时间为 Date 对象
    parseTimeToDate(time) {
      if (!time) return null
      // 如果是数字（时间戳）
      if (typeof time === 'number') {
        // 如果是10位时间戳，转换为13位
        if (time.toString().length === 10) {
          return new Date(time * 1000)
        }
        return new Date(time)
      }
      // 如果是字符串
      if (typeof time === 'string') {
        // 如果是纯数字字符串，尝试转换为时间戳
        if (/^\d+$/.test(time)) {
          const numTime = parseInt(time)
          if (numTime.toString().length === 10) {
            return new Date(numTime * 1000)
          }
          return new Date(numTime)
        }
        // 尝试直接解析字符串
        const date = new Date(time)
        // 检查是否有效
        if (!isNaN(date.getTime())) {
          return date
        }
      }
      return null
    },
    // 格式化时长（秒转分钟/小时）
    formatDuration(seconds) {
      if (!seconds || seconds === 0) return '0分钟'
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      if (hours > 0) {
        return minutes > 0 ? `${hours}小时${minutes}分钟` : `${hours}小时`
      }
      return `${minutes}分钟`
    },
    // 获取直播状态文本
    getLiveStateText(state) {
      const stateMap = {
        0: '未开始',
        1: '直播中',
        2: '已结束',
        3: '已取消'
      }
      return stateMap[state] || '未知状态'
    },
    showShareDetailDialog() {
      this.$emit('handleShow', this.liveData, 2)
    },
    showAdminDialog() {
      if (this.liveData.liveAdminPOList && this.liveData.liveAdminPOList.length > 0) {
        // 转换数据格式以匹配admins组件
        const adminList = this.liveData.liveAdminPOList.map(admin => ({
          avatar: admin.adminAvatar || '',
          name: admin.adminName || '',
          role: admin.adminPosition || ''
        }))
        this.$refs.adminisVue.handleShow(adminList)
      } else {
        this.$refs.adminisVue.handleShow([])
      }
    },
    // 查看观看人数
    handleViewUsers() {
      // TODO: 跳转到观看人数页面
      this.$message.info('查看观看人数功能待实现')
    },
    // 查看福袋
    handleViewLuckyBag() {
      // TODO: 跳转到福袋页面
      this.$message.info('查看福袋功能待实现')
    },
    // 查看余额商城订单
    handleViewYueOrders() {
      // TODO: 跳转到余额商城订单页面
      this.$message.info('查看余额商城订单功能待实现')
    },
    // 查看秒杀订单
    handleViewKillOrders() {
      // TODO: 跳转到秒杀订单页面
      this.$message.info('查看秒杀订单功能待实现')
    },
    // 查看充值订单
    handleViewTuitionOrders() {
      // TODO: 跳转到充值订单页面
      this.$message.info('查看充值订单功能待实现')
    },
    doQueryList({ pageNo, pageSize } = {}) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      // 请求接口，更新 tableData 和 total
      // TODO: 实现直播商品列表查询
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.doQueryList()
    },
    handlePageChange(page) {
      this.query.pageNo = page
      this.doQueryList()
    }
  }
}
</script>

<style scoped>
.filter-form {
  margin-bottom: 10px;
}
.info-card {
  margin-bottom: 20px;
}
.info-block {
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
  line-height: 1.8;
}
.table-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}
.page-size-label {
  margin-left: 16px;
  color: #909399;
  font-size: 13px;
}
.filter-checkbox {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 10px;
  height: 33px;
  width: 176px;
  display: inline-block;
  background: #fff;
  box-sizing: border-box;
}
</style>
